<template>
	<div class="w1200 ">
		<div v-loading="loading"  :element-loading-text="$t('拼命加载中')">
			<div v-if="img_list.length > 0">
				<template v-for="(item,index) in img_list">
					<img class="index_0" :src="item.thumb" alt="" srcset="">
				</template>
			</div>
			<div v-else style="text-align: center;padding: 40px 0;">
				<img style="width: 217px;height: 177px;" src="https://api.ezlunch.club/pc/image/29.png" alt="" srcset="">
			</div>
		</div>
	   
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				loading:true,
				img_list:[],
			}
		},
		created() {
			this.post641e624160dd0()
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post641e624160dd0()
			},
			// 轮播图
			post641e624160dd0(){
				this.$api.post(this.$apiUrls.post641e624160dd0,{type:3}).then((res) => {
					if(res.code == 1){
						this.img_list = res.data
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.index_0{
		width: 100%;
		margin: 20px 0 0 0;
	}
	

	
</style>